define('app/views/dc_subscribe_box_view',['app/setup'], function (takhfifan) {
  takhfifan.DCSubscribeBox = Backbone.View.extend({
    events: {
      'submit .tkh-dc-subscribe-box__form': 'subscribe',
      'click .tkh-dc-subscribe-box__notify-btn': 'notifyBox'
    },

    boxTemplate: ( $('#tkh-dc-subscription-box-template').length > 0 ) ?
      _.template( $('#tkh-dc-subscription-box-template').html() ) : '',

    initialize: function () {
      this.notifyUrl = this.$el.data('notifyUrl');
      takhfifan.eventHub.on('modal:disableTriggerElement', function(options) {
        this.$('.tkh-dc-popup').remove();
      },this);
    },

    subscribe: function (e) {
      e.preventDefault();
      var $form = $(e.target);
      this.sendRequest($form.serializeArray(), $form.prop('action'),$form.prop('method'));
      $form[0].reset();
    },

    notifyBox: function (e) {
      //show form in popup.
      //submit that form
      var $target = $(e.target);
      takhfifan.eventHub.trigger('modal:showModalWithContent',
        {
          triggerElement: this.$el,
          fadeTimeIn: 400,
          elementToOperate: this.$el
        });
      this.renderSubBoxPopup($target.data('id'));
    },

    sendRequest: function (data, url, method) {
      var _this = this;

      this.$el.addClass('loading-view');
      takhfifan.eventHub.trigger('modal:closeModalWithContent');
      $.ajax({
        method: method || "post" ,
        url: url || this.notifyUrl,
        data: data
      })
        .done(function (data) {
          // data.status could be "already-exists" or "success"
          takhfifan.eventHub.trigger('message:show', {
            msg: 'ایمیل شما با موفقیت ثبت شد.',
            type: 'success'
          });
        })
        .fail(function () {
          takhfifan.eventHub.trigger('message:show', {
            msg: 'در برقراری ارتباط خطایی پیش آمد',
            type: 'error'
          });
        })
        .always(function () {
          _this.$el.removeClass('loading-view');
        });
    },

    renderSubBoxPopup: function(id){
      this.$el.append(this.boxTemplate({id:id}));
    }
  })
});

